import React from 'react';
import {connect} from 'react-redux';
import * as s from './selectors';
import * as a from './actions';
import * as r from 'ramda';
import './reducers';

const TopCategorySwitch = connect(
    (state) => ({
        categories: s.selectCategories(state)
    }),
    (dispatch) => ({
        selectCategory: id => {
            dispatch(a.toggleCategory(id));
        }
    })
)(({categories, selectCategory}) => {
   return (
       <div className="product-config__header product-config-half-pizza">
           {r.map(category => {
               let activeClass = category.active ? 'product-option--valid' : '';
               return (
                   <div key={category.id} className={`product-option ${activeClass} product-option--half`}>
                       <button onClick={() => selectCategory(category.id)} type="button" className="btn btn--more">
                           <span className="btn__label">{category.label}</span>
                       </button>
                   </div>
               )
           }, categories)}
       </div>
   ) ;
});

const Pizza = connect(null, (dispatch, ownProps) => ({
    selectPizza: (e, id) => {
        let wasIconClicked = (target) => {
            let wasIconClicked = false;
            while (! target.classList.contains('btn--more') && ! wasIconClicked) {
                wasIconClicked = target.classList.contains('product__tag');
                target = target.parentElement;
            }
            return wasIconClicked;
        };
        wasIconClicked(e.target) || dispatch(a.selectPizza(id))
    }
}))((({pizza, selectPizza}) => {
    let selectedClass = pizza.selected ? 'product-option--valid' : '';
    return (
        <div className={`product-option ${selectedClass}`}>
            <button onClick={(e) => selectPizza(e, pizza.id)} type="button" className="btn btn--more">
                 <span className="product__tag product__tag--info product__tag--info-half-pizza" data-show-product-detail={`[data-product-id=${pizza.fullPizzaId}]`}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19" width="19" height="19">
                        <circle style={{fill: '#fff'}} cx="9.5" cy="9.6" r="8.8"/>
                        <path style={{fill: '#d34442'}}
                              d="M18.8 9.4c0-5.1-4.1-9.2-9.2-9.2h-.1-.1C4.3.2.1 4.4.1 9.5c0 5.1 4.2 9.3 9.3 9.3s9.3-4.2 9.3-9.3c.1 0 .1 0 .1-.1zM10.9 15c0 .8-.6 1.4-1.4 1.4-.8 0-1.4-.6-1.4-1.4V8.1c0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4V15zM9.5 5.4c-.8 0-1.4-.6-1.4-1.4s.6-1.4 1.4-1.4c.8 0 1.4.6 1.4 1.4s-.7 1.4-1.4 1.4z"/>
                    </svg>
                </span>
                <span className="btn__label" style={{paddingLeft: '20px'}}>{pizza.label}</span>
            </button>
        </div>
    )
}));

const PizzaList = connect((state, ownProps) => ({
    list: s.selectList(state)
}))(({list}) => {
    return (
        <div>
            {r.map(pizza => {
                return <Pizza key={pizza.id} pizza={pizza}/>;
            }, list)}
        </div>
    )
});

export const HalfPizzaConfigurator = connect(
    (state, ownProps) => ({
        modalId: s.selectSubmitButtonModalConfig(state).submitButtonModalId,
        text: s.selectTexts(state).submitButtonText
    })
)(({modalId, text}) => {
    return (
        <div className="product-config">
            <div className="product-config__form">
                <TopCategorySwitch/>
                <PizzaList/>
                <input id="half-pizza-submit-button" type="submit"
                       className="product__cart btn btn--active btn--block"
                       data-modal={modalId}
                       value={text}
                />
            </div>
        </div>
    );
});

export const HalfPizzaConfiguratorImage = connect(
    (state, ownProps) => ({
        images: s.selectImages(state)
    })
)(({images}) => {
    return images.filter(i =>i).map((image) => {
        return <img key={image.position} src={image.src} alt={image.alt} className={'product-custom__img half_pizza_image-' + image.position}/>
    })
});
